var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarometer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 105,
    viewBox: "0 0 115 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8984 0H58.1016V4.81279H56.8984V0Z",
    fill: "#022B3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.441 4.74875L81.5401 5.23814L79.5826 9.63484L78.4834 9.14546L80.441 4.74875Z",
    fill: "#022B3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.017 18.6619L100.822 19.556L97.2452 22.7764L96.4401 21.8823L100.017 18.6619Z",
    fill: "#022B3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.241 39.3348L112.613 40.4791L108.035 41.9664L107.664 40.822L112.241 39.3348Z",
    fill: "#022B3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115 63.192L114.874 64.3886L110.088 63.8855L110.214 62.6889L115 63.192Z",
    fill: "#022B3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.817 86.1091L107.215 87.1511L103.047 84.7447L103.649 83.7027L107.817 86.1091Z",
    fill: "#022B3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9333 104.123L90.9599 104.83L88.131 100.937L89.1044 100.229L91.9333 104.123Z",
    fill: "#022B3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0402 104.83L23.0668 104.123L25.8957 100.229L26.8691 100.937L24.0402 104.83Z",
    fill: "#022B3A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78499 87.1513L7.18339 86.1093L11.3514 83.7029L11.953 84.7449L7.78499 87.1513Z",
    fill: "#022B3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.125768 64.3887L0 63.1921L4.78643 62.689L4.91219 63.8856L0.125768 64.3887Z",
    fill: "#022B3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38735 40.4793L2.75915 39.3349L7.33639 40.8222L6.96458 41.9665L2.38735 40.4793Z",
    fill: "#022B3A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1782 19.5555L14.9832 18.6613L18.5598 21.8817L17.7548 22.7759L14.1782 19.5555Z",
    fill: "#022B3A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4599 5.23814L34.559 4.74875L36.5166 9.14546L35.4174 9.63484L33.4599 5.23814Z",
    fill: "#022B3A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarometer);
export default __webpack_public_path__ + "static/media/barometer.8e50d24c22b60fda7a5d4812f25843a9.svg";
export { ForwardRef as ReactComponent };